import PopupCreateReceipt from './PopupCreateReceipt';

export default PopupCreateReceipt;
